import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();

  const onPrimaryButtonContainerClick = useCallback(() => {
    navigate("/passcode");
  }, [navigate]);

  const onExitButtonClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div className="relative w-full h-[1024px] overflow-hidden flex flex-col pt-32 px-0 pb-0 box-border items-center justify-start gap-[32px] bg-[url(/public/signup@3x.png)] bg-cover bg-no-repeat bg-[top] text-left text-5xl text-dark font-footnote md:items-center md:justify-start md:pt-16 md:box-border sm:items-center sm:justify-start sm:pt-8 sm:box-border">
      <div className="rounded-4xl bg-light flex flex-col py-16 px-8 items-center justify-start gap-[64px] border-b-[4px] border-solid border-lavender">
        <img
          className="relative w-[153.75px] h-[32.23px]"
          alt=""
          src="/prairie1.svg"
        />
        <div
          className="self-stretch rounded-31xl bg-gold flex flex-row py-[22px] px-8 items-center justify-center cursor-pointer hover:bg-goldenrod-100"
        >
          <a href="link here"><b className="relative">Sign up</b></a>
        </div>
      </div>
      <button
        className="[border:none] py-[22px] px-8 bg-light rounded-31xl flex flex-row items-center justify-center hover:bg-gray-200"
        onClick={onExitButtonClick}
        autoFocus
        // disabled
      >
        <b className="relative text-base font-footnote text-dark text-left">
          Exit
        </b>
      </button>
    </div>
  );
};

export default SignUp;
